export default [
        {
          path: 'venue/:id',
          name: 'venue',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "venue" */ './views/Admin/Venue.vue')
        },
        {
          path: 'venue/:id/edit',
          name: 'venue-edit',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "venue" */ './views/Admin/VenueEdit.vue')
        },
        {
          path: 'splash',
          name: 'adminSplash',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "venue" */ './views/Admin/Splash.vue')
        },
        {
          path: 'settings',
          name: 'settings',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "venue" */ './views/Admin/Settings.vue')
        },{
          path: 'updates',
          name: 'updates',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "venue" */ './views/Admin/Updates.vue')
        },
      ]